export default "__VITE_ASSET__Bdc05q3___"